import {
  LoadingOutlined,
  UserOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  LockOutlined
} from '@ant-design/icons';
import { Spin, Input } from 'antd';
import ReCAPTCHA from 'react-google-recaptcha';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { T } from 'react-translator-component';

import * as S from './styled';
import { useRegisterPage } from './useRegisterPage';

import { useTheme } from '../../../../hooks/useTheme';
import { Shell } from '../../../atoms/Shell/Shell';
import { CelescLogos } from '../CelescLogos';

const RegisterPage = () => {
  const {
    captchaRef,
    handleFormSubmit,
    isLoginLoading,
    isVerified,
    recaptchaExpired,
    recaptchaLoaded
  } = useRegisterPage();

  const { theme } = useTheme();

  return (
    <S.LoginFormPageWrapper>
      {theme ? (
        <img
          src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo.png`}
          className={`${theme}-logo-auth`}
        />
      ) : <Shell height={50} width={200}  />}

      <S.LoginFormWrapper>
        <S.LoginFormTitleWrapper>
          <S.LoginFormTitle>{T('Register')}</S.LoginFormTitle>
        </S.LoginFormTitleWrapper>

        <form onSubmit={handleFormSubmit}>
          <S.LoginFormInputWrapper>
            <Input
              className="input"
              id="email"
              type="email"
              size="large"
              placeholder="Usuário"
              prefix={<UserOutlined style={{'color':'#c1c6cb'}} />}
            />
          </S.LoginFormInputWrapper>

          <S.LoginFormInputWrapper>
            <Input.Password
              className="input"
              id="password"
              type="password"
              size="large"
              prefix={<LockOutlined style={{'color':'#c1c6cb'}}/>}
              placeholder={T('Password')}
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
          </S.LoginFormInputWrapper>

          <S.ReCaptchaWrapper>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              render="explicit"
              onChange={recaptchaLoaded}
              onExpired={recaptchaExpired}
              ref={captchaRef}
            />
          </S.ReCaptchaWrapper>

          {isLoginLoading ? (
            <Spin
              style={{ display: 'flex', justifyContent: 'center' }}
              indicator={<LoadingOutlined style={{ fontSize: 40, margin: 10 }} spin />}
            />
          ) : (
            <S.LoginFormButtonWrapper>
              <S.LoginFormButton type="submit" disabled={!isVerified}>
                {T('Submit')}
              </S.LoginFormButton>
            </S.LoginFormButtonWrapper>
          )}

          <S.RegisterText>
            <Link to="/auth/login">
              {T('Already have registration?')} {T('Click here')}.
            </Link>
          </S.RegisterText>
        </form>
      </S.LoginFormWrapper>

      {theme === 'celesc' && <CelescLogos />}
    </S.LoginFormPageWrapper>
  );
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps)(RegisterPage);
